import { memo } from 'react';

import { useBreakpointsContext } from '@air/provider-media-query';

import { CommentModeButton } from '~/components/DiscussionsV2/InitialCommentInput/components/CommentModeButton';
import { isMobileAgent } from '~/utils/PlatformHelpers';

export type NewDiscussionActionsProps = {
  canAnnotateClip: boolean;
  onEnterCommentMode?: () => void;
};

export const NewDiscussionActions = memo(({ canAnnotateClip, onEnterCommentMode }: NewDiscussionActionsProps) => {
  const { isAboveMediumScreen } = useBreakpointsContext();
  const isDesktop = isAboveMediumScreen && !isMobileAgent;

  return isDesktop && canAnnotateClip ? (
    <div className="mr-1 flex items-center gap-1">
      <CommentModeButton canAnnotateClip={canAnnotateClip} onEnterCommentMode={onEnterCommentMode} />
    </div>
  ) : null;
});

NewDiscussionActions.displayName = 'NewDiscussionActions';
